'use strict';

exports.__esModule = true;
exports['default'] = ['/:tournamentId', '/:tournamentId/fixture', '/:tournamentId/la-final', '/:tournamentId/:groupRef', '/:tournamentId/:groupRef/:teamId'];
module.exports = exports['default'];